import {
  Box,
  Coin,
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Icon,
} from '@customerio/pluma-components/react';

const NotFoundPage = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" h="full" w="full">
      <EmptyState>
        <EmptyStateGraphic>
          <Coin size="lg" shape="rounded-square" colorVariant="yellow">
            <Icon name="caution" />
          </Coin>
        </EmptyStateGraphic>
        <EmptyStateTitle>Whoops!</EmptyStateTitle>
        <EmptyStateDescription>Sorry, but this page doesn't exist :(</EmptyStateDescription>
      </EmptyState>
    </Box>
  );
};

export default NotFoundPage;
